import { ItemFieldsType } from './associationItems'

// action 类型定义
const GOODS_ACTION_TYPE = {
  SET_INCLUDE_TESTING_FEE: 'SET_INCLUDE_TESTING_FEE', // 是否含检测费
  SET_INCLUDE_PACKING_FEE: 'SET_INCLUDE_PACKING_FEE', // 是否含安装费
  GET_PLATFORM_LIST: 'GET_PLATFORM_LIST', // 获取平台
  SET_PLATFORM_LIST: 'SET_PLATFORM_LIST', // 设置平台
  GET_CONNECTED_PROJECT_CODE: 'GET_CONNECTED_PROJECT_CODE', // 获取已对接项目编码
  SET_CONNECTED_PROJECT_CODE: 'SET_CONNECTED_PROJECT_CODE', // 设置已对接项目编码
  SET_MATCH_DISABLED: 'SET_MATCH_DISABLED', // 匹配按钮禁用
  GET_AREA_OPTIONS: 'GET_AREA_OPTIONS', // 获取区域
  SET_AREA_OPTIONS: 'SET_AREA_OPTIONS', // 设置区域
  SET_LOCAL_CATEGORY_INFO: 'SET_LOCAL_CATEGORY_INFO', // 设置电商供应商物料的四级类目信息
  SET_SMART_VISIBLE: 'SET_SMART_VISIBLE', // 智能赋码数据弹框
  TAX_LOADING: 'TAX_LOADING', // 智能赋码加载状态
  SMART_REVENUE: 'SMART_REVENUE', // 智能赋码获取到的data
  SELECT_REVENUE: 'SELECT_REVENUE', // 选中的税码数据
  SELECT_ROW_KEYS: 'SELECT_ROW_KEYS', // 表格单选框选中数据
}

// 表单控件信息
export interface FieldInfo {
  fieldMeaning: string // 字段含义
  controlType: ItemFieldsType // 控件类型
  fieldKey: string // 字段
  fieldName: string // 字段名(中文名称)
  fieldValue?: string // 字段值
  fieldValueName?: string // 字段值名称
  relateField?: string // 关联字段
  relateFieldEnumValue?: string // 关联字段枚举值
  id: string // 字段 id
  rangeList: {
    id: string
    key: string
    value: string
  }[] // 字段取值范围
  require: boolean // 字段是否必须
  remark: string // 备注
}

export interface SmartRevenueData {
  revenueCode: string // 税收分类编码
  prob: string // 匹配度
  taxRate: string // 税率
  parentName: string // 税收分类名称
  desc: string // 描述
  shortName: string // 简称
  category: string // 类目名称
}

// 项目型字段
export interface PlatformField {
  itemFields: FieldInfo[]
  code: string // 下单平台编码
  name: string // 下单平台名称
  pushRequirements: string // 物料推送要求
  showDiscountRate?: '1' | '0' // SCP分类折扣是否展示(1-是 0-否)
}

// 区域
export interface AreaInfo {
  code: string
  name: string
  children?: AreaInfo[]
}

// 已对接项目数据类型
export interface ConnectedProjectCode {
  platformName: string
  platformCode: string
  platformAbbreviations: string
  pushRequirements: string
  projectCategory: string
}

// 当前状态接口
interface GoodsReducerState {
  includeTestingFee: string
  includePackingFee: string
  platformList: PlatformField[]
  connectedProjectData: ConnectedProjectCode[] // 已对接项目数据
  matchDisabled: boolean
  areaOptions: AreaInfo[]
  localCategoryId: string
  localCategoryName: string
  smartRevenueVisible: boolean
  taxLoading: boolean // 智能赋码加载状态
  smartRevenueData: SmartRevenueData[]
  selectRevenue: SmartRevenueData
  selectedRowKeys: string[]
}

// 默认数据
export const defaultState: GoodsReducerState = {
  includeTestingFee: '',
  includePackingFee: '',
  platformList: [],
  connectedProjectData: [], // 已对接项目数据
  matchDisabled: false,
  areaOptions: [],
  localCategoryId: '',
  localCategoryName: '',
  smartRevenueVisible: false,
  taxLoading: false,
  smartRevenueData: [],
  selectRevenue: {
    revenueCode: '',
    prob: '',
    taxRate: '',
    parentName: '',
    desc: '',
    shortName: '',
    category: '',
  },
  selectedRowKeys: [],
}

interface Action {
  type: string
  value: any
}

export enum CategorySourceData {
  MALL = '1',
  PLM = '2',
}

// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    case GOODS_ACTION_TYPE.SET_INCLUDE_TESTING_FEE:
      arr.includeTestingFee = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_INCLUDE_PACKING_FEE:
      arr.includePackingFee = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_PLATFORM_LIST:
      arr.platformList = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_CONNECTED_PROJECT_CODE:
      arr.connectedProjectData = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_MATCH_DISABLED:
      arr.matchDisabled = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_AREA_OPTIONS:
      arr.areaOptions = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_SMART_VISIBLE:
      arr.smartRevenueVisible = action.value
      return arr
    case GOODS_ACTION_TYPE.TAX_LOADING:
      arr.taxLoading = action.value
      return arr
    case GOODS_ACTION_TYPE.SMART_REVENUE:
      arr.smartRevenueData = action.value
      return arr
    case GOODS_ACTION_TYPE.SELECT_REVENUE:
      arr.selectRevenue = action.value
      return arr
    case GOODS_ACTION_TYPE.SELECT_ROW_KEYS:
      arr.selectedRowKeys = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_LOCAL_CATEGORY_INFO:
      arr.localCategoryId = action.value.id
      arr.localCategoryName = action.value.name
      return arr
    default:
      return state
  }
}

// 是否含检测费
export const setIncludeTestingAction = (param: string) => ({
  type: GOODS_ACTION_TYPE.SET_INCLUDE_TESTING_FEE,
  value: param,
})

// 是否含安装费
export const setIncludePackingAction = (param: string) => ({
  type: GOODS_ACTION_TYPE.SET_INCLUDE_PACKING_FEE,
  value: param,
})

// 获取平台
export const getPlatformListAction = () => ({
  type: GOODS_ACTION_TYPE.GET_PLATFORM_LIST,
})

// 设置平台
export const setPlatformListAction = (param: PlatformField[]) => ({
  type: GOODS_ACTION_TYPE.SET_PLATFORM_LIST,
  value: param,
})

// 获取已对接项目编码
export const getConnectedProjectCodeAction = () => ({
  type: GOODS_ACTION_TYPE.GET_CONNECTED_PROJECT_CODE,
})

// 设置已对接项目编码
export const setConnectedProjectCodeAction = (
  param: ConnectedProjectCode[],
) => ({
  type: GOODS_ACTION_TYPE.SET_CONNECTED_PROJECT_CODE,
  value: param,
})

// 智能赋码数据弹框
export const setSmartRevenueVisibleAction = (param: boolean) => ({
  type: GOODS_ACTION_TYPE.SET_SMART_VISIBLE,
  value: param,
})
// 智能赋码获取税编信息loading
export const setTaxLoadingAction = (param: boolean) => ({
  type: GOODS_ACTION_TYPE.TAX_LOADING,
  value: param,
})
// 智能赋码获取到的data
export const setSmartRevenueDataAction = (param: SmartRevenueData[]) => ({
  type: GOODS_ACTION_TYPE.SMART_REVENUE,
  value: param,
})
// 选中的税码数据
export const setSelectRevenueAction = (param: SmartRevenueData) => ({
  type: GOODS_ACTION_TYPE.SELECT_REVENUE,
  value: param,
})
// 表格单选框选中数据
export const setSelectedRowKeysAction = (param: string[]) => ({
  type: GOODS_ACTION_TYPE.SELECT_ROW_KEYS,
  value: param,
})

// 匹配按钮禁用
export const setMatchDisabledAction = (param: boolean) => ({
  type: GOODS_ACTION_TYPE.SET_MATCH_DISABLED,
  value: param,
})

// 获取区域
export const getAreaOptionsAction = () => ({
  type: GOODS_ACTION_TYPE.GET_AREA_OPTIONS,
})

// 设置区域
export const setAreaOptionsAction = (param: AreaInfo[]) => ({
  type: GOODS_ACTION_TYPE.SET_AREA_OPTIONS,
  value: param,
})

// 设置电商供应商物料的四级类目信息
export const setLocalCategoryInfoAction = (param: {
  name: string
  id: string
}) => ({
  type: GOODS_ACTION_TYPE.SET_LOCAL_CATEGORY_INFO,
  value: param,
})

export const {
  GET_PLATFORM_LIST,
  GET_AREA_OPTIONS,
  GET_CONNECTED_PROJECT_CODE,
} = GOODS_ACTION_TYPE
import { ItemFieldsType } from './associationItems'

// action 类型定义
const GOODS_ACTION_TYPE = {
  SET_INCLUDE_TESTING_FEE: 'SET_INCLUDE_TESTING_FEE', // 是否含检测费
  SET_INCLUDE_PACKING_FEE: 'SET_INCLUDE_PACKING_FEE', // 是否含安装费
  GET_PLATFORM_LIST: 'GET_PLATFORM_LIST', // 获取平台
  SET_PLATFORM_LIST: 'SET_PLATFORM_LIST', // 设置平台
  GET_CONNECTED_PROJECT_CODE: 'GET_CONNECTED_PROJECT_CODE', // 获取已对接项目编码
  SET_CONNECTED_PROJECT_CODE: 'SET_CONNECTED_PROJECT_CODE', // 设置已对接项目编码
  SET_MATCH_DISABLED: 'SET_MATCH_DISABLED', // 匹配按钮禁用
  GET_AREA_OPTIONS: 'GET_AREA_OPTIONS', // 获取区域
  SET_AREA_OPTIONS: 'SET_AREA_OPTIONS', // 设置区域
  SET_LOCAL_CATEGORY_INFO: 'SET_LOCAL_CATEGORY_INFO', // 设置电商供应商物料的四级类目信息
  SET_SMART_VISIBLE: 'SET_SMART_VISIBLE', // 智能赋码数据弹框
  TAX_LOADING: 'TAX_LOADING', // 智能赋码加载状态
  SMART_REVENUE: 'SMART_REVENUE', // 智能赋码获取到的data
  SELECT_REVENUE: 'SELECT_REVENUE', // 选中的税码数据
  SELECT_ROW_KEYS: 'SELECT_ROW_KEYS', // 表格单选框选中数据
}

// 表单控件信息
export interface FieldInfo {
  fieldMeaning: string // 字段含义
  controlType: ItemFieldsType // 控件类型
  fieldKey: string // 字段
  fieldName: string // 字段名(中文名称)
  fieldValue?: string // 字段值
  fieldValueName?: string // 字段值名称
  relateField?: string // 关联字段
  relateFieldEnumValue?: string // 关联字段枚举值
  id: string // 字段 id
  rangeList: {
    id: string
    key: string
    value: string
  }[] // 字段取值范围
  require: boolean // 字段是否必须
  remark: string // 备注
}

export interface SmartRevenueData {
  revenueCode: string // 税收分类编码
  prob: string // 匹配度
  taxRate: string // 税率
  parentName: string // 税收分类名称
  desc: string // 描述
  shortName: string // 简称
  category: string // 类目名称
}

// 项目型字段
export interface PlatformField {
  itemFields: FieldInfo[]
  code: string // 下单平台编码
  name: string // 下单平台名称
  pushRequirements: string // 物料推送要求
  showDiscountRate?: '1' | '0' // SCP分类折扣是否展示(1-是 0-否)
}

// 区域
export interface AreaInfo {
  code: string
  name: string
  children?: AreaInfo[]
}

// 已对接项目数据类型
export interface ConnectedProjectCode {
  platformName: string
  platformCode: string
  platformAbbreviations: string
  pushRequirements: string
  projectCategory: string
}

// 当前状态接口
interface GoodsReducerState {
  includeTestingFee: string
  includePackingFee: string
  platformList: PlatformField[]
  connectedProjectData: ConnectedProjectCode[] // 已对接项目数据
  matchDisabled: boolean
  areaOptions: AreaInfo[]
  localCategoryId: string
  localCategoryName: string
  smartRevenueVisible: boolean
  taxLoading: boolean // 智能赋码加载状态
  smartRevenueData: SmartRevenueData[]
  selectRevenue: SmartRevenueData
  selectedRowKeys: string[]
}

// 默认数据
export const defaultState: GoodsReducerState = {
  includeTestingFee: '',
  includePackingFee: '',
  platformList: [],
  connectedProjectData: [], // 已对接项目数据
  matchDisabled: false,
  areaOptions: [],
  localCategoryId: '',
  localCategoryName: '',
  smartRevenueVisible: false,
  taxLoading: false,
  smartRevenueData: [],
  selectRevenue: {
    revenueCode: '',
    prob: '',
    taxRate: '',
    parentName: '',
    desc: '',
    shortName: '',
    category: '',
  },
  selectedRowKeys: [],
}

interface Action {
  type: string
  value: any
}

export enum CategorySourceData {
  MALL = '1',
  PLM = '2',
}

// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    case GOODS_ACTION_TYPE.SET_INCLUDE_TESTING_FEE:
      arr.includeTestingFee = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_INCLUDE_PACKING_FEE:
      arr.includePackingFee = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_PLATFORM_LIST:
      arr.platformList = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_CONNECTED_PROJECT_CODE:
      arr.connectedProjectData = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_MATCH_DISABLED:
      arr.matchDisabled = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_AREA_OPTIONS:
      arr.areaOptions = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_SMART_VISIBLE:
      arr.smartRevenueVisible = action.value
      return arr
    case GOODS_ACTION_TYPE.TAX_LOADING:
      arr.taxLoading = action.value
      return arr
    case GOODS_ACTION_TYPE.SMART_REVENUE:
      arr.smartRevenueData = action.value
      return arr
    case GOODS_ACTION_TYPE.SELECT_REVENUE:
      arr.selectRevenue = action.value
      return arr
    case GOODS_ACTION_TYPE.SELECT_ROW_KEYS:
      arr.selectedRowKeys = action.value
      return arr
    case GOODS_ACTION_TYPE.SET_LOCAL_CATEGORY_INFO:
      arr.localCategoryId = action.value.id
      arr.localCategoryName = action.value.name
      return arr
    default:
      return state
  }
}

// 是否含检测费
export const setIncludeTestingAction = (param: string) => ({
  type: GOODS_ACTION_TYPE.SET_INCLUDE_TESTING_FEE,
  value: param,
})

// 是否含安装费
export const setIncludePackingAction = (param: string) => ({
  type: GOODS_ACTION_TYPE.SET_INCLUDE_PACKING_FEE,
  value: param,
})

// 获取平台
export const getPlatformListAction = () => ({
  type: GOODS_ACTION_TYPE.GET_PLATFORM_LIST,
})

// 设置平台
export const setPlatformListAction = (param: PlatformField[]) => ({
  type: GOODS_ACTION_TYPE.SET_PLATFORM_LIST,
  value: param,
})

// 获取已对接项目编码
export const getConnectedProjectCodeAction = () => ({
  type: GOODS_ACTION_TYPE.GET_CONNECTED_PROJECT_CODE,
})

// 设置已对接项目编码
export const setConnectedProjectCodeAction = (
  param: ConnectedProjectCode[],
) => ({
  type: GOODS_ACTION_TYPE.SET_CONNECTED_PROJECT_CODE,
  value: param,
})

// 智能赋码数据弹框
export const setSmartRevenueVisibleAction = (param: boolean) => ({
  type: GOODS_ACTION_TYPE.SET_SMART_VISIBLE,
  value: param,
})
// 智能赋码获取税编信息loading
export const setTaxLoadingAction = (param: boolean) => ({
  type: GOODS_ACTION_TYPE.TAX_LOADING,
  value: param,
})
// 智能赋码获取到的data
export const setSmartRevenueDataAction = (param: SmartRevenueData[]) => ({
  type: GOODS_ACTION_TYPE.SMART_REVENUE,
  value: param,
})
// 选中的税码数据
export const setSelectRevenueAction = (param: SmartRevenueData) => ({
  type: GOODS_ACTION_TYPE.SELECT_REVENUE,
  value: param,
})
// 表格单选框选中数据
export const setSelectedRowKeysAction = (param: string[]) => ({
  type: GOODS_ACTION_TYPE.SELECT_ROW_KEYS,
  value: param,
})

// 匹配按钮禁用
export const setMatchDisabledAction = (param: boolean) => ({
  type: GOODS_ACTION_TYPE.SET_MATCH_DISABLED,
  value: param,
})

// 获取区域
export const getAreaOptionsAction = () => ({
  type: GOODS_ACTION_TYPE.GET_AREA_OPTIONS,
})

// 设置区域
export const setAreaOptionsAction = (param: AreaInfo[]) => ({
  type: GOODS_ACTION_TYPE.SET_AREA_OPTIONS,
  value: param,
})

// 设置电商供应商物料的四级类目信息
export const setLocalCategoryInfoAction = (param: {
  name: string
  id: string
}) => ({
  type: GOODS_ACTION_TYPE.SET_LOCAL_CATEGORY_INFO,
  value: param,
})

export const {
  GET_PLATFORM_LIST,
  GET_AREA_OPTIONS,
  GET_CONNECTED_PROJECT_CODE,
} = GOODS_ACTION_TYPE
